/**
*
* Alert
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import theme from '../../theme';
import Button from '../Button';

const SryledAlert = styled.div`
    /* background: rgba(51, 51, 51, 0.91); */
    /* position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: -9; */
    z-index: 99;
    background: ${theme.secondaryColor};
    padding:20px;
  .container{
    width: 100%;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      width: 100%;
      margin:0px;
      border-radius:0px;
      padding:15px 5px;
    };
    text-align: center;
    border-radius: 5px;
    /* margin: 20px; */
    padding: 20px;
    position: fixed;
    right: 0;
    left:0;
    font-size: 12px;
    /* box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.4); */
    -moz-animation: cssAnimation 0s ease-in 2s forwards;
    /* Firefox */
    -webkit-animation: cssAnimation 0s ease-in 2s forwards;
    /* Safari and Chrome */
    -o-animation: cssAnimation 0s ease-in 2s forwards;
    /* Opera */
    animation: cssAnimation 0s ease-in 2s forwards;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-name: bounceOut;
    animation-name: bounceOut;
    z-index: 9999;
    top:0;
    &.success{
      color: #155724;
      background-color: #d4edda;
      border:solid 1px #c3e6cb;
    }
    &.error{
      color: #721c24 !important;
      background-color: #f8d7da;
      border:solid 1px #f5c6cb;
      z-index: 99999;
    }
    &.info{
      color: #004085;
      background-color: #cce5ff;
      border:solid 1px #b8daff;
    }
    p{
      margin:0px;
    }


@-webkit-keyframes bounceOut {
  20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  50%,
  55% {
    opacity: 1;
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  to {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
}

@keyframes bounceOut {
  20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9);
    transform: scale3d(0.9, 0.9, 0.9);
  }

  50%,
  55% {
    opacity: 1;
    -webkit-transform: scale3d(1.1, 1.1, 1.1);
    transform: scale3d(1.1, 1.1, 1.1);
  }

  to {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
    ${Button}{
      display:block;
      width:100%;
      border-radius:5px;
    }
  }

  ${({ alertType }) => {
    if (alertType === 'popup') {
      return css`
          display: inline-block;
          width: 100%;
          background: ${theme.transparentColor};
          padding:0px;
        .container{
        position:static;
        width: 85%;
        animation:none;
        margin: auto;
        &.error{
          color: ${theme.primaryColor};
          font-size: 16px;
          font-weight:600;
          text-align: left;
          background: ${theme.transparentColor};
          border: 0;
          padding: 0;
          margin: 0;
          margin-top:15px;
          width: 100%;
          p{
            color: ${theme.primaryColor}; !important;
            line-height: 20px;
          }
        }
        &.success{
          color: ${theme.alertGreen};
          text-align: left;
          background: ${theme.transparentColor};
          border: 0;
          padding: 0;
          margin: 0;
          margin-top:0px;
          width: 100%;
          p{
            color: ${theme.alertGreen} !important;
            line-height: 20px;
          }
    }
        }
      `;
    }
    if (alertType === 'ribbon') {
      return css`
        background-color: ${theme.secondaryColor};
        color: ${theme.whiteColor};
      `;
    }
    if (alertType === 'fullScreen') {
      return css`
        color: ${theme.whiteColor};
        background: ${theme.transparentColor};
        padding:0px;
      `;
    }
  }}
  `;

function Alert(props) {
  const { reason, msg_type, alertType } = props;
  const className = `container ${msg_type}`;
  if (reason) {
    return (
      <SryledAlert alertType={alertType}>
        <div className={className}>
          <p>{reason}</p>
          {/* <Button type="primary">OK</Button> */}
        </div>
      </SryledAlert>
    );
  }
  return (<div></div>);
}

Alert.propTypes = {
  reason: PropTypes.string,
  msg_type: PropTypes.string,
  alertType: PropTypes.oneOf([
    'popup', 'fullScreen', 'ribbon',
  ]),
};

Alert.defaultProps = {
  alertType: 'fullScreen',
  reason: '',
};

export default Alert;



// WEBPACK FOOTER //
// client/components/Alert/index.js